"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isCookieAvailable = (typeof document) != "undefined";
class I18nResolver {
    constructor(translations, preferredLanguage) {
        this.translations = translations;
        this.cookieName = "i18n-language";
        this.currentLanguage = null;
        // get the current language from cookie, browser locale
        const language = preferredLanguage || this.getCookie(this.cookieName) || this.getBrowserLanguage();
        this.language = this.findBestMatch(language) || "default";
    }
    get translation() {
        return this.translations[this.currentLanguage];
    }
    get language() {
        return this.currentLanguage;
    }
    set language(lang) {
        this.currentLanguage = lang;
        this.setCookie(this.cookieName, lang);
    }
    setCookie(name, value, expires, path) {
        if (!isCookieAvailable) {
            return;
        }
        let expiration = expires ? "; expires=" + expires.toUTCString() : "";
        let cookieStr = `${name}=${value}${expiration}`;
        if (path) {
            cookieStr += ";path=" + path;
        }
        document.cookie = cookieStr;
    }
    getCookie(name) {
        if (!isCookieAvailable) {
            return null;
        }
        let cookie = document.cookie
            .split(";")
            .map(cookieStr => cookieStr.trim())
            .find(cookieStr => cookieStr.startsWith(name + "="));
        return cookie ? cookie.replace(name + "=", "") : null;
    }
    getBrowserLanguage() {
        return navigator.language || navigator.userLanguage; // fallback for IE
    }
    findBestMatch(language) {
        if (this.translations[language]) {
            return language;
        }
        // in case of language variants, e.g. en-US, check for basic variant (en) as well
        const langPrefix = language.split("-")[0];
        if (this.translations[langPrefix]) {
            return langPrefix;
        }
        return null;
    }
}
exports.I18nResolver = I18nResolver;



//////////////////
// WEBPACK FOOTER
// ./node_modules/i18n-ts/lib/core/I18nResolver.js
// module id = 883
// module chunks = 0